import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { ScrollText, ArrowLeft } from "lucide-react";

const Section = ({ n, title, children }) => (
  <section className="mt-8">
    <h2 className="font-display text-xl font-extrabold text-[#03281B]">
      <span className="text-[#008057]">{n}.</span> {title}
    </h2>
    <div className="text-slate-600 mt-2 leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
        <Link to="/" data-testid="terms-back-link" className="inline-flex items-center gap-2 text-sm text-[#008057] font-semibold hover:underline">
          <ArrowLeft size={16} /> Back to home
        </Link>
        <div className="mt-6 flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-[#F2F8F5] text-[#008057] flex items-center justify-center shrink-0"><ScrollText size={24} /></div>
          <div>
            <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-[#03281B]">Terms of Service</h1>
            <p className="text-sm text-slate-500 mt-1">Effective Date: June 4, 2026</p>
          </div>
        </div>

        <p className="text-slate-600 mt-6 leading-relaxed">
          By accessing or using the Northcrest Athletics website and services — including registration for the Sporting CP Camp San Diego 2027 — you agree to these Terms of Service.
        </p>

        <Section n="1" title="Company Information">
          <p>
            Northcrest Athletics LLC<br />
            8 The Green, Suite B<br />
            Dover, DE 19901<br />
            United States
          </p>
        </Section>

        <Section n="2" title="Services">
          <p>Northcrest provides athlete advisory, educational consulting, recruitment support, athlete representation, NIL-readiness guidance, camps, mentorship, and related services.</p>
          <p>Northcrest does not guarantee:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>university admission</li>
            <li>athletic scholarships</li>
            <li>roster placement</li>
            <li>NIL opportunities</li>
            <li>recruitment outcomes</li>
          </ul>
          <p>All decisions remain at the discretion of universities, coaches, athletic departments, and governing bodies.</p>
        </Section>

        <Section n="3" title="User Responsibilities">
          <p>Users agree to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>provide accurate information</li>
            <li>comply with applicable laws</li>
            <li>use the website lawfully</li>
            <li>avoid misuse of the platform</li>
          </ul>
        </Section>

        <Section n="4" title="Intellectual Property">
          <p>All website content, branding, logos, materials, graphics, and text are the property of Northcrest Athletics LLC unless otherwise stated.</p>
          <p>Unauthorized reproduction or distribution is prohibited.</p>
        </Section>

        <Section n="5" title="Limitation of Liability">
          <p>To the maximum extent permitted by law, Northcrest Athletics LLC shall not be liable for:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>indirect damages</li>
            <li>lost opportunities</li>
            <li>recruitment outcomes</li>
            <li>scholarship decisions</li>
            <li>university admissions decisions</li>
          </ul>
          <p>Use of the website and services is at the user's own risk.</p>
        </Section>

        <Section n="6" title="Third-Party Links">
          <p>The website may contain links to third-party websites. Northcrest is not responsible for external content or policies.</p>
        </Section>

        <Section n="7" title="Governing Law">
          <p>These Terms shall be governed by the laws of the State of Delaware, United States, unless mandatory consumer protection laws require otherwise.</p>
        </Section>

        <Section n="8" title="Modifications">
          <p>Northcrest reserves the right to modify these Terms at any time.</p>
        </Section>

        <Section n="9" title="Contact">
          <p><a href="mailto:legal@northcrestathletics.com" className="text-[#008057] font-semibold hover:underline">legal@northcrestathletics.com</a></p>
        </Section>

        <p className="text-xs text-slate-400 mt-10 pt-6 border-t border-[#E2EBF0]">Effective Date: June 4, 2026 &middot; Northcrest Athletics LLC</p>
      </div>
    </div>
  );
}
